export const updateLegalProcessDocumentService =
  (fetch) => async (id, file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch({
        url: `/api/v1/siniestros-viales/documentos-procesos-juridicos/${id}`,
        method: "put",
        body: formData,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
